<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-12">
            <h3 class="page-title">Điều Phối & Ghép Đơn</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Dashboard</router-link></li>
              <li class="breadcrumb-item active">Điều phối</li>
            </ul>
          </div>
        </div>
      </div>
      
      <div v-if="actionError" class="alert alert-danger">{{ actionError }}</div>
      
      <div class="row">
          <div class="col-lg-8">
              <div class="card card-table">
                  <div class="card-header">
                      <h4 class="card-title">Hàng Đợi (Pool) - Đơn Sẵn Sàng Giao</h4>
                  </div>
                  <div class="card-body">
                       <div v-if="isLoadingPool" class="text-center p-3">...Loading...</div>
                       <div v-else-if="poolError" class="alert alert-danger">{{ poolError }}</div>
                       <div v-else-if="poolItems.length === 0" class="text-center text-muted p-3">Hàng đợi trống.</div>
                       
                       <div v-else class="table-responsive">
                            <table class="table table-hover table-sm">
                                <thead class="thead-light">
                                    <tr>
                                        <th style="width: 20px;">
                                            <input type="checkbox" @change="toggleSelectAll($event)">
                                        </th>
                                        <th>Đơn hàng</th>
                                        <th>Vật tư (Kho yêu cầu)</th>
                                        <th>Địa chỉ Giao</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in poolItems" :key="item.id">
                                        <td>
                                            <input type="checkbox" v-model="selectedOrders" :value="item.id">
                                        </td>
                                        <td>
                                            <strong>{{ item.tenDonHang }}</strong>
                                            <small class="d-block text-muted">Hẹn: {{ formatDateTime(item.thoiGianHen) }}</small>
                                        </td>
                                        <td>
                                            <span v-for="stop in item.diemDung.filter(d => d.loaiDiemDung === 'KHO_LAY')" :key="stop.id" class="badge badge-info mr-1">
                                                {{ stop.tenDiemDung }}
                                            </span>
                                        </td>
                                        <td>{{ item.diaChiGiaoHang }}</td>
                                    </tr>
                                </tbody>
                            </table>
                       </div>
                       </div>
              </div>
          </div>
          
          <div class="col-lg-4">
              <div class="card">
                  <div class="card-header">
                       <h4 class="card-title">Gán Chuyến (Push)</h4>
                  </div>
                  <div class="card-body">
                      <div v-if="selectedOrders.length === 0" class="text-muted text-center">
                          Vui lòng tick chọn các đơn hàng ở Hàng Đợi (Pool) để ghép đơn.
                      </div>
                      <form v-else @submit.prevent="handleAssignTrip">
                           <div class="alert alert-info">
                               Đã chọn {{ selectedOrders.length }} đơn hàng.
                           </div>
                           <div class="form-group">
                               <label>Gán cho Lệnh (Tài xế/Xe đang chờ)</label>
                               <select v-model="selectedPhanCongId" class="form-control" required :disabled="isLoadingPhanCong">
                                   <option :value="null" disabled>-- Chọn tài xế/xe đang chờ --</option>
                                   <option v-for="pc in phanCongOptions" :key="pc.id" :value="pc.id">
                                       {{ pc.tenTaiXe }} - (Xe: {{ pc.xeBienSo }})
                                   </option>
                               </select>
                               <small v-if="phanCongError" class="text-danger">{{ phanCongError }}</small>
                           </div>
                           <button type="submit" class="btn btn-primary btn-block" :disabled="isLoadingAction">
                                <span v-if="isLoadingAction" class="spinner-border spinner-border-sm"></span>
                                Gán {{ selectedOrders.length }} đơn vào Chuyến
                           </button>
                      </form>
                  </div>
              </div>
          </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
// Import store MỚI
import { useDieuPhoiDonHangStore } from '@/stores/dieuPhoiDonHangStore'; 

// --- Helpers Format ---
function formatDateTime(s) { /* ... */ }
// --- Hết Helpers ---

export default {
  name: 'QuanLyDonHangDieuPhoi',
  data() {
    return {
      selectedOrders: [], // Danh sách ID các đơn được tick
      selectedPhanCongId: null, // Lệnh (Tài xế/Xe) được chọn
    };
  },
  computed: {
    ...mapState(useDieuPhoiDonHangStore, [
      'isLoadingPool', 'poolError', 'poolItems', 'poolTotalPages',
      'isLoadingPhanCong', 'phanCongError', 'phanCongOptions',
      'isLoadingAction', 'actionError'
    ]),
  },
  methods: {
    ...mapActions(useDieuPhoiDonHangStore, [
      'fetchPool',
      'fetchPhanCongOptions',
      'fetchRunning',
      'assignOrders'
    ]),
    
    formatDateTime, // (Helper)

    toggleSelectAll(event) {
        if (event.target.checked) {
            this.selectedOrders = this.poolItems.map(item => item.id);
        } else {
            this.selectedOrders = [];
        }
    },
    
    async handleAssignTrip() {
        if (!this.selectedPhanCongId || this.selectedOrders.length === 0) {
            alert("Vui lòng chọn Lệnh (Tài xế) và ít nhất 1 Đơn hàng.");
            return;
        }
        try {
            await this.assignOrders(this.selectedPhanCongId, this.selectedOrders);
            alert("Gán đơn thành công!");
            this.selectedOrders = []; // Reset
            this.selectedPhanCongId = null;
        } catch(e) {
            // Lỗi đã được store xử lý
            alert(this.actionError || "Lỗi không xác định");
        }
    }
  },
  mounted() {
    this.fetchPool(); // Tải hàng đợi
    this.fetchPhanCongOptions(); // Tải danh sách tài xế rảnh
    // this.fetchRunning(); // (Tải tab 2 nếu cần)
  }
};
</script>

<style scoped>
/* (Style cho Tabs, Badge, Table... giữ nguyên) */
.table-responsive { max-height: 60vh; }
.card-table .card-body { padding: 0; }
pre { white-space: pre-wrap; margin: 0; font-family: inherit; }
.nav-tabs-scrollable { /* ... */ }
/* ... */
</style>